module.exports = __webpack_public_path__ + "img/accessory_hat_01.ce30ccfd.svg";